/**
 * Results
 *
 * View that handles interactions within the results container
 *
 * @return {View}
 */

OT.createNS('OT.Redesign.Views.Results.ResultsContainer');

OT.Redesign.Views.Results.ResultsContainer = OT.Common.Views.Results.ResultsContainer.extend({
    events: function () {
        return _.extend({}, OT.Common.Views.Results.ResultsContainer.prototype.events, {
            'mouseover .rest-name': '',
            'mouseout .rest-name': '',
            'mouseover .rest-row-offer-link': 'createRestaurantModal',
            'mouseover .timeslot': 'createOfferTooltip',
            'mouseout .timeslot': 'removeOfferTooltip',
            'click .timeslot': 'navigateToSlot',
            'click #pop_see_all_link': 'firePopOnlySearch',
            'click .reserve-link': 'createSingleSearchModal',
            'click #availability_link': 'toggleAvailability'
        });
    },

    /**
     * Toggle availability search/no availabilty search
     */
    toggleAvailability: function (e) {
        e.preventDefault();

        OT.Search.Params.set({
            from: null,
            IntersperseAvailability: true
        });

        OT.Search.Requests.Results.get();
    },

    firePopOnlySearch: function () {
        OT.Search.Params.set({
            OnlyPopTimes: true,
            From: null
        });

        $('#Times_onlyPopTimes').attr('checked', true);
        $('[for="Times_onlyPopTimes"]').addClass('highlight');

        OT.Search.Requests.Results.get();

        return false;
    },

    /**
    * Create restaurant modal delay, view and remove it
    */
    createRestaurantModal: function (e) {
        var self = this;

        if (this.filterModalIsShowing()) {
            return false;
        }

        var $result = $(e.currentTarget);
        var $target = $result.parents('.result');
        var name = $result.hasClass('offer') ? 'offer-name' : 'restaurant-name';
        var rowOffers = $target.data('offers') || '';
        var offerIds = typeof rowOffers === 'number' ? [rowOffers + ''] : rowOffers.split(',');
        var data = _.filter(OT.Search.Data.get().Offers, function (offer) {
                return _.indexOf(offerIds, offer.Id.toString()) < 0;
            });

        this.createModalDelay(this.restaurantModalDelay, 'restaurantModal', function () {
            OT.Search.views.restaurantModal.setAttributes({
                $target: $target,
                templateData: data
            }).render();
        });
    },

    removeRestaurantModal: function () {
        this.removeModalDelay(this.removeModalDelayTime, 'restaurantModal');
    },

    createSingleSearchModal: function (e) {
        e.preventDefault();

        if (this.filterModalIsShowing()) {
            return false;
        }

        var self = this;
        var $target = $(e.currentTarget);
        var $row = $target.parents('.result');
        var restaurantName = $row.find('.rest-name').text();
        var restaurantId = $row.attr('data-rid');
        var isLunchLink = $target.hasClass('lunch');
        var isDinnerLink = $target.hasClass('dinner');
        var promoId = OT.Search.Params.get('PromoId');
        var ref = OT.Search.Params.get('Ref');
        var profileUrl = $target.attr('data-profile-url');

        this.createModalDelay(0, 'singleSearchModal', function () {
            OT.Search.views.singleSearchModal.display({
                $reserveLink: $target,
                restaurantName: restaurantName,
                restaurantId: restaurantId,
                isLunchLink: isLunchLink,
                isDinnerLink: isDinnerLink,
                promoId: promoId,
                ref: ref,
                profileUrl: profileUrl
            });
        });
    },

    removeSingleSearchModal: function () {
        this.removeModalDelay(0, 'singleSearchModal');
    },

    /**
     * Create tooltip delay, view and remove it
     */
    createOfferTooltip: function (e) {
        var self = this;
        var $target = $(e.currentTarget);
        var hasPop = $target.data('has-pop') === 'True' || $target.data('has-pop');
        var rowOffers = $target.data('offers') || '';
        var offerIds = typeof rowOffers === 'number' ? [rowOffers + ''] : rowOffers.split(',');
        var offers = _.filter(OT.Search.Data.get().Offers, function (offer) {
            return _.indexOf(offerIds, offer.Id.toString()) < 0;
        });
        var data = {
            Offers: _.map(offers, function (offer) {
                return offer.Name;
            })
        };

        if (!OT.Search.Data.get().Display.ShowOffersTooltip) {
            return false;
        }

        if (offerIds[0] !== '' || hasPop === true) {
            if (hasPop === true) {
                data.Offers.push(Resources.Shared.Common.Modals.Offers_PopOfferTitle);
            }

            self.isToolTip = true;
            self.createModalDelay(self.tooltipDelay, 'offerTooltip', function () {
                OT.Search.views.tooltipModal.setAttributes({
                    $target: $target,
                    templateData: data
                });

                if (!OT.Search.views.tooltipModal.$el.is('visible')) {
                    OT.Search.views.tooltipModal.render();
                }
            });
        }
    },

    removeOfferTooltip: function () {
        if (this.isToolTip) {
            this.removeModalDelay(this.removeModalDelayTime, 'offerTooltip');
        }

        this.isToolTip = false;
    },

    navigateToSlot: function (e) {
        var isInstantEligible = $(e.target).data('instant-eligible');

        if (!OT.InstantCommon ||
            !Boolean(isInstantEligible)) {
            return true;
        }

        var element = e.target;
        var slotData = {
            rid: element.getAttribute('data-rid'),
            p: element.getAttribute('data-covers'),
            d: element.getAttribute('data-datetime'),
            restaurantName: element.getAttribute('data-name')
        };
        OT.InstantCommon.modal.handleSlotClick(e, { slotData: slotData, src: 'search' });
    },

    /**
     * Override these functions so they no longer work.
     * It's easier than removing the events
     */
    createPriceModal: function () { },
    removePriceModal: function () { }
});
